import { defineTapPropertyExtension } from '@iotize/tap';
import { DataManager } from '@iotize/tap/data';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    data: DataManager;
  }
}

export const _TAP_EXTENSION_DATA_ = defineTapPropertyExtension(
  'data',
  (context) => {
    return new DataManager(context.tap);
  },
);

/**
 * @deprecated use _TAP_EXTENSION_DATA_ instead
 */
export const __DEFINED_PROPERTY_GETTER_DATA_MANAGER__ = _TAP_EXTENSION_DATA_;
